/* eslint-disable react/require-default-props */
import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import { slide as Menu } from 'light-react-burger-menu'
import { MdMenu } from '@react-icons/all-files/md/MdMenu'

import CloseIcon from "../../../images/svg/icons/close-small.svg"
import "./mobileMenu.scss"

const renderLink = linkItem => {

  if (linkItem.target == "_blank" || linkItem.target == null) {
    return (
      <a
        target={linkItem.target == '_blank' ? "_blank" : "_self"}
        rel="noreferrer noopener"
        href={linkItem.url}
        title={linkItem.label}
      >
        {linkItem.label}
      </a>
    )
  } else {
    const link = linkItem.url.replace(`https://vibemap.com`, ``)

    return (
      <a href={link} title={linkItem.label}>
        {linkItem.label}
      </a>
    )
  }

}

const MobileMenu = () => {
  const data = useStaticQuery(graphql`
    query MobileMenuQuery {
      allWpMenu(
        filter: { slug: { in: ["top-navigation", "main-navigation"] } }
      ) {
        edges {
          node {
            id
            menuItems {
              nodes {
                url
                label
                target
                id
                cssClasses
                parentId
                childItems {
                  nodes {
                    url
                    label
                    target
                    id
                    cssClasses
                  }
                }
              }
            }
            slug
            name
          }
        }
      }
    }
  `)

  let mainNavigationData, topNavigationData

  const [menuOpen, setMenuOpen] = useState(false)

  data.allWpMenu.edges.map(({ node }) => {
    if (node.slug === "main-navigation") {
      mainNavigationData = node
    } else {
      topNavigationData = node
    }
  })

  var isMenuOpen = function (state) {
    console.log('isMenuOpen ', state)
    setMenuOpen(state.isOpen)
  }

  const iconSize = 40
  const icon = <MdMenu size={iconSize} />

  return (
    <Menu
      isOpen={menuOpen}
      width={"90%"}
      id="mobile-navigation-menu"
      className="mobile-nav-container"
      customBurgerIcon={icon}
      outerContainerId="main-content-wrapper"
      burgerButtonClassName="menu-button"
      bodyClassName="no-scroll"
      customCrossIcon={false}
      right
      disableAutoFocus
      onStateChange={isMenuOpen}
    >
      <button
        onClick={() => {
          //console.log('Button clicked !!!', menuOpen)
          setMenuOpen(false)
          //isMenuOpen(true)
        }}
        className="close-button"
      >
        <CloseIcon />
      </button>
      <ul className="main-links">
        {mainNavigationData.menuItems.nodes.map(menuItem => {
          // Skip child items at the top level
          if (menuItem.parentId) return null;
          
          const hasChildren = menuItem.childItems && menuItem.childItems.nodes.length > 0;
          
          return (
            <li
              key={menuItem.id}
              className={`post post-id-${
                menuItem.id
              } ${menuItem.cssClasses.join(" ")} ${hasChildren ? 'has-children' : ''}`}
            >
              <div onClick={() => {
                setMenuOpen(false)
              }}>
                {renderLink(menuItem)}
              </div>
              {hasChildren && (
                <ul className="sub-menu">
                  {menuItem.childItems.nodes.map(childItem => (
                    <li
                      key={childItem.id}
                      className={`sub-item ${childItem.cssClasses.join(" ")}`}
                      onClick={() => {
                        setMenuOpen(false)
                      }}
                    >
                      {renderLink(childItem)}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          )
        })}
      </ul>
      <div className="menu-separator"></div>
      <ul className="sub-links">
        {topNavigationData.menuItems.nodes.map(menuItem => {
          return (
            <li
              onClick={() => {
                setMenuOpen(false)
              }}
              key={menuItem.id}
              className={`post post-id-${
                menuItem.id
              } ${menuItem.cssClasses.join(" ")}`}
            >
              {renderLink(menuItem)}
            </li>
          )
        })}
      </ul>
    </Menu>
  )
}

export default MobileMenu
